import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
// This file was auto-generated using scripts/generate-icons.js

/**
 * Icon generated from globe.svg
 */
export default function GlobeIcon(props) {
  return _jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    "aria-hidden": "true",
    viewBox: "0 0 16 16",
    "data-component": "GlobeIcon",
    ...props,
    children: _jsxs("g", {
      "fill-rule": "evenodd",
      children: [_jsx("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
      }), _jsx("path", {
        fill: "currentColor",
        d: "M16 8A8 8 0 1 0 0 8a8 8 0 0 0 16 0m-8.86 2.516a23 23 0 0 1 1.72.002c-.093.809-.232 1.543-.407 2.157l-.06.198-.073.222a5 5 0 0 1-.229.55L8 13.81l-.078-.138-.078-.16a6 6 0 0 1-.297-.836 13.7 13.7 0 0 1-.407-2.16m-4.06.604-.17.058a6.02 6.02 0 0 0 2.8 2.37 12.6 12.6 0 0 1-.467-2.03l-.054-.383-.054-.451a13 13 0 0 0-1.807.36zm7.731.016.055-.452.323.046c.741.115 1.39.268 1.902.447a6.02 6.02 0 0 1-2.8 2.37c.228-.693.402-1.508.52-2.411M2.146 6.673l-.001.012a6 6 0 0 0 .003 2.643c.781-.285 1.761-.504 2.86-.645l-.006-.38v-.606l.006-.378c-1.099-.141-2.079-.36-2.862-.646m11.578.046.129-.046Q13.999 7.314 14 8q-.002.687-.146 1.328c-.783-.285-1.763-.504-2.862-.645l.006-.38L11 8q0-.305-.006-.603l-.002-.078c1.039-.134 1.972-.337 2.732-.6m-4.73.762-.259.01a26 26 0 0 1-1.73-.009L7 8q0 .262.006.52a24 24 0 0 1 1.988 0L9 8zM7.922 2.33l.077-.14.08.14.077.16c.102.227.203.508.297.835.175.614.314 1.349.407 2.16a23 23 0 0 1-1.72-.002c.093-.81.232-1.544.407-2.158a5.6 5.6 0 0 1 .375-.995m-2.212.123-.045.019a6.02 6.02 0 0 0-2.756 2.351c.584.206 1.348.376 2.225.494l.055-.453c.118-.903.292-1.718.52-2.411m4.63.157-.05-.158.265.118a6.03 6.03 0 0 1 2.537 2.254c-.585.205-1.35.375-2.227.494l-.054-.454-.058-.411a13 13 0 0 0-.412-1.843"
      })]
    })
  });
}
//# sourceMappingURL=Globe.js.map